import axios from 'axios';
import { useQuery } from 'react-query';

import errorHandler from '../../../helpers/errorHandler';
import { emptyResults } from '../../_data_sources/constants';

export default function useMarkers(jobMapId, params, options) {
  return useQuery(
    ['markers', jobMapId, params],
    async ({ signal }) => {
      const { center, bounds, geohash, ...data } = { ...params };
      const isInvalidBounds =
        bounds &&
        (bounds.north === bounds.south || bounds.west === bounds.east);

      if (!data.zoom || isInvalidBounds) return emptyResults;

      // geohash & bounds are mutually exclusive params
      if (geohash) {
        data.geohash = geohash;
      } else {
        data.bounds = bounds;
      }

      const res = await axios
        .get(
          window.Routes.api_job_map_markers_path({
            company_id: 1,
            job_map_id: jobMapId,
            ...data,
          }),
          {
            signal,
          }
        )
        .catch(errorHandler.handleError);

      return res ? res.data : emptyResults;
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      ...options,
    }
  );
}
